import {
  React,
  useState,
  createContext,
  useContext
} from 'react';
import api from 'src/services/api';
import { SiteContext } from './SiteContext';

export const CategoryContext = createContext();

const CategoryProvider = (prop) => {
  const baseUrl = 'admin/category';
  const { children } = prop;
  const [category, setCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [urlPaginate, setUrlPaginate] = useState();
  const {
    setNotifyMessage,
    notifyMessageSave,
    closeNotifyMessage,
    notifyMessageError,
    loading,
    setLoading
  } = useContext(SiteContext);
  const [search, setSearch] = useState();

  const getCategorys = async () => {
    setLoading(true);
    await api.get(`${baseUrl}/all`)
      .then((response) => {
        setCategories(response.data);
        setUrlPaginate(response.data.meta.path);
        setLoading(false);
        return true;
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        return false;
      });
  };

  const getCategory = async (id) => {
    setLoading(true);
    await api.get(`${baseUrl}/get/${id}`)
      .then((response) => {
        setCategory(response.data.data);
        setLoading(false);
        return true;
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        return false;
      });
  };

  const searchCategorys = async (param) => {
    setLoading(true);
    if (!param) {
      await getCategorys();
    } else {
      await api.post(`${baseUrl}/search`, { param })
        .then((response) => {
          setCategories(response.data);
          setUrlPaginate(response.data.meta.path);
          setSearch(param);
          setLoading(false);
        })
        .catch((err) => {
          setCategories([]);
          setLoading(false);
          console.log(err);
        });
    }
  };

  const saveCategory = async (data) => {
    setLoading(true);
    const serverResponse = await api.post(`${baseUrl}/create`, data)
      .then((response) => {
        setCategory(response.data.data);
        setLoading(false);
        notifyMessageSave('Salvo');
        return true;
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        return false;
      });
    return serverResponse;
  };

  const updateCategory = async (id, data) => {
    setLoading(true);
    await api.post(`${baseUrl}/update/${id}`, data)
      .then((response) => {
        setCategory(response.data.data);
        notifyMessageSave('Atualizado');
        setLoading(false);
        return true;
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        return false;
      });
  };

  const paginateCategory = async (number) => {
    setLoading(true);
    if (search) {
      await api.post(`${urlPaginate}?page=${number}`, { search })
        .then((response) => {
          setCategories(response.data);
          setLoading(false);
        })
        .catch((err) => {
          setCategories([]);
          setLoading(false);
          console.log(err);
        });
    } else {
      await api.get(`${urlPaginate}?page=${number}`)
        .then((response) => {
          setCategories(response.data);
          setLoading(false);
        })
        .catch((err) => {
          setCategories([]);
          setLoading(false);
          console.log(err);
        });
    }
  };

  const deleteCategory = async (id) => {
    setLoading(true);
    const response = await api.delete(`${baseUrl}/delete/${id}`)
      .then(() => {
        setLoading(false);
        notifyMessageSave('excluido');
        getCategorys();
        return true;
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        return false;
      });
    return response;
  };

  return (
    <CategoryContext.Provider
      value={{
        category,
        categories,
        loading,
        urlPaginate,
        getCategorys,
        saveCategory,
        updateCategory,
        setCategory,
        deleteCategory,
        paginateCategory,
        getCategory,
        setNotifyMessage,
        searchCategorys,
        closeNotifyMessage,
        notifyMessageError,
        notifyMessageSave
      }}
    >
      { children }
    </CategoryContext.Provider>

  );
};

export default CategoryProvider;
